<template>
  <div>
    <v-container fill-height fluid>
    <v-row>
      <v-spacer></v-spacer>
      <v-btn
        v-if="can('create editors')"
        @click="showEditorModal(0)"
        color="primary"
        dark
        class="mb-2"
      >{{ $t("NEW") }}
      </v-btn>
    </v-row>
    </v-container>
    <v-data-table
      :headers="headers"
      :items="items"
      :server-items-length="totalItems"
      :no-data-text="$t('NO_DATA')"
      :no-results-text="$t('NO_DATA')"
      hide-default-footer
      :options.sync="pagination"
      :loading="loading"
      class="elevation-1"
    >


      <template v-slot:item.actions="{ item }">
            <v-layout row wrap>
              <v-flex>
                <v-btn
                  v-if="can('delete editors')"
                  icon
                  color="red"
                  @click="deleteEditor(item.id)"
                >
                  <v-icon>cancel</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
      </template>
    </v-data-table>
    <Paginator
      :total-items="totalItems"
      :page.sync="pagination.page"
      :items-per-page.sync="pagination.itemsPerPage"
      @change="fetchEditor"
    />
  </div>
</template>

<script>
  import { mapActions } from 'vuex';

  import { editorsGroupService } from '../../../utils/services/editorsGroup.service';


  import editorListModal from '../../modals/EditorsGroups/EditorListModal.vue';
  import Paginator from '../../shared/Paginator';

  export default {
    name: 'EditorGroupEditorTableDetails',
    components: { Paginator },
    props: {
      editorGroup: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        loading: false,
        items: [],
        totalItems: 0,
        pagination: {
          page: 1,
          itemsPerPage: 10,
          sortDesc: [false],
          sortBy: ['name'],
        },
        headers: [
          {
            text: this.$t('fields.name'),
            align: 'left',
            value: 'name',
          },
          { text: this.$t('fields.actions'), value: 'actions', sortable: false, align: 'center' },
        ],
      };
    },
    computed: {
      requestFilters() {
        const filters = {};
        if (this.pagination.sortBy.length === 1 && this.pagination.sortDesc.length === 1) {
          const { sortBy, sortDesc } = this.pagination;
          filters.sortBy = sortBy;
          filters.sortDesc = sortDesc;
        }
        return filters;
      },
    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('modal', ['showModal', 'hideModal']),
      ...mapActions('alert', ['showToast']),

      async showEditorModal(id) {
        this.showModal({
          component: editorListModal,
            data: {
              stored: {
                id,
              },
          },
          options: {
            title: this.$t('EDITOR'),
            onSave: (
              form,
              error,
            ) => editorsGroupService.saveEditors(this.editorGroup.id, form)
            .then(() => {
              this.fetchEditor(this.pagination.page);
              this.hideModal({});
              this.showToast({ type: 'success', message: this.$t('SAVED') });
            })
            .catch(error => {
              this.handleError(error, this.errors);
            })
            .finally(() => {
              this.fetchEditor(this.pagination.page);
            }),
          },
        });
      },

      async fetchEditor(forcePage) {
        this.loading = true;
        const { page, itemsPerPage } = this.pagination;
        return editorsGroupService.editors(this.editorGroup.id, {
          page: page || forcePage || 1,
          itemsPerPage,
          filters: this.requestFilters,
        })
        .then((response) => {
            this.items = response.data.data;
            this.totalItems = response.data.meta.total;
            this.pagination = this.getPagination(
              response.data.meta,
              { oldPagination: this.pagination, forcePage },
            );
        })
        .catch(error => {
          this.handleError(error, this.errors);
        })
        .finally(() => {
          this.loading = false;
        });
      },

      async deleteEditor(id) {
          this.showConfirm({
            onConfirm: () => {
              this.loading = true;
              return editorsGroupService.removeEditors(this.editorGroup.id, id)
              .then(() => {
                this.showToast({ type: 'success', message: this.$t('DELETED') });
                this.fetchEditor(this.pagination.page);
              })
              .catch(error => {
                this.handleError(error, this.errors);
              })
              .finally(() => {
                this.loading = false;
              });
            },
          });
      },
    },
    async created() {
      await this.fetchEditor();
    },
  };
</script>
